<template>
  <div class="right_container" :style="{height:height+'px',width:width+'px'}">
    <div class="default_page" :style="{top:(height/2-15)+'px'}">
        欢迎使用海南白马广告媒体投资有限公司项目管理系统！
    </div>
  </div>
</template>

<script>
  export default {
    data: ()=>{
      return {
      }
    },
    props:[ "height", "width"],
    created(){
    },
    mounted(){
       console.log(this.width)
    },
    destroyed() {
    },
    methods: {
    },
  }
</script>

<style scoped>
.right_container .default_page { font-size: 24px; color: #00499a; text-align: center; background: #fff; position: absolute; width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/auditing/welcome.vue